export class AccessRight {
   ID: any ;
   Name: any;
   Priority: number;
   IsAllowed: boolean;
}